import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateAccountingPeriod } from './accountingPeriod';
import type { UpdateAccountingPeriodRequest } from './accountingPeriod.types';
import {
  ACCOUNTING_PERIOD_METADATA_KEY,
  ACCOUNTING_PERIODS_KEY,
} from './constants';

export const useUpdateAccountingPeriod = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      data,
    }: {
      id: number;
      data: UpdateAccountingPeriodRequest;
    }) => updateAccountingPeriod(id, data),
    onSuccess: () => {
      // Invalidate and refetch all accounting periods queries
      queryClient.invalidateQueries({ queryKey: [ACCOUNTING_PERIODS_KEY] });
      // Also invalidate metadata since periods might affect counts
      queryClient.invalidateQueries({
        queryKey: [ACCOUNTING_PERIOD_METADATA_KEY],
      });
    },
  });
};
